export default __webpack_public_path__ + "static/tierSilver-artboard-53-4dfcc1e2e90e6ecf372d00d66c78c5ff.png";